<div class="nav-flexbox-container">
  @if(_isBelowBreakpoint){
  <button
    class="nav-menu"
    mat-icon-button
    [matMenuTriggerFor]="navMenu"
    overlayPanelClass="compass-menu"
    yPosition="below"
    aria-label="Navigation options"
  >
    <span class="material-icons-outlined menu-icon"> menu </span>
  </button>
  <mat-menu #navMenu="matMenu">
    <a
      href="{{ link.url }}"
      class="compass-menu-item"
      *ngFor="let link of navlinks"
      mat-menu-item
      [attr.data-cy]="link.dataCy"
      >{{ link.title }}</a
    >
  </mat-menu>
  } @else{
  <div class="nav-flexbox-item" *ngFor="let link of navlinks">
    <div [ngClass]="{ 'nav-flexbox-item-current': link.current === 1 }">
      <a href="{{ link.url }}" [attr.data-cy]="link.dataCy">{{ link.title }}</a>
    </div>
  </div>
  }
</div>
